interface subscription {
  id: number;
  title: string;
}

export const subscriptionOffers: subscription[] = [
  {
    id: 1,
    title: "Unlock All Interactive Activity Content",
  },
  {
    id: 2,
    title: "Learn Up To 12 African Language",
  },
  {
    id: 3,
    title: "No Ads",
  },
  {
    id: 4,
    title: "Practice Your With Native Speakers",
  },
];
